/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/CompanySubscriptionServiceLevel', 'model/CompanyUserServiceLevelBase'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./CompanySubscriptionServiceLevel'), require('./CompanyUserServiceLevelBase'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.CompanySubscriptionReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.CompanySubscriptionServiceLevel, root.ForStractionServiceApi.CompanyUserServiceLevelBase);
  }
}(this, function(ApiClient, CompanySubscriptionServiceLevel, CompanyUserServiceLevelBase) {
  'use strict';




  /**
   * The CompanySubscriptionReport model module.
   * @module model/CompanySubscriptionReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>CompanySubscriptionReport</code>.
   * @alias module:model/CompanySubscriptionReport
   * @class
   */
  var exports = function() {
    var _this = this;






  };

  /**
   * Constructs a <code>CompanySubscriptionReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CompanySubscriptionReport} obj Optional instance to populate.
   * @return {module:model/CompanySubscriptionReport} The populated <code>CompanySubscriptionReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('ProductPackageID')) {
        obj['ProductPackageID'] = ApiClient.convertToType(data['ProductPackageID'], 'Integer');
      }
      if (data.hasOwnProperty('CreationChannelID')) {
        obj['CreationChannelID'] = ApiClient.convertToType(data['CreationChannelID'], 'Integer');
      }
      if (data.hasOwnProperty('CreationChannelName')) {
        obj['CreationChannelName'] = ApiClient.convertToType(data['CreationChannelName'], 'String');
      }
      if (data.hasOwnProperty('ServiceLevels')) {
        obj['ServiceLevels'] = ApiClient.convertToType(data['ServiceLevels'], [CompanySubscriptionServiceLevel]);
      }
      if (data.hasOwnProperty('Users')) {
        obj['Users'] = ApiClient.convertToType(data['Users'], [CompanyUserServiceLevelBase]);
      }
    }
    return obj;
  }

  /**
   * @member {Integer} ProductPackageID
   * @default 0
   */
  exports.prototype['ProductPackageID'] = 0;
  /**
   * @member {Integer} CreationChannelID
   * @default 0
   */
  exports.prototype['CreationChannelID'] = 0;
  /**
   * @member {String} CreationChannelName
   * @default ''
   */
  exports.prototype['CreationChannelName'] = '';
  /**
   * @member {Array.<module:model/CompanySubscriptionServiceLevel>} ServiceLevels
   */
  exports.prototype['ServiceLevels'] = undefined;
  /**
   * @member {Array.<module:model/CompanyUserServiceLevelBase>} Users
   */
  exports.prototype['Users'] = undefined;



  return exports;
}));


